'use client';

import styles from './collection-feedback.module.scss';
import CloseIcon from 'assets/icons/close-x.svg';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'src/navigation';
import { useSearchParams } from 'next/navigation';
const getSessionToken = (): string | null => {
	if (typeof window !== 'undefined') {
		return sessionStorage.getItem('collectionSurvey');
	}
	return null;
};

export const CollectionFeedback = ({
	alwaysShow = false,
}: {
	alwaysShow?: boolean;
}) => {
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [isOpen, setIsOpen] = useState(true);
	const [sessionToken, setSessionToken] = useState(null);
	const [response, setResponse] = useState(null);
	const params = useSearchParams();
	const query = params.get('q');
	const timerRef = useRef(null);
	const queryString = params.toString();

	useEffect(() => {
		//Read the sessionStorage clientside.
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setSessionToken(getSessionToken() === 'alreadySeen');
	}, []);

	//If the user does not interact for one minute, fade out.
	//Reset when query changes.
	useEffect(() => {
		const fadeOut = setTimeout(() => {
			!hasSubmitted && setIsOpen(false);
		}, 60000);

		return () => clearTimeout(fadeOut);
	}, [hasSubmitted, query]);

	useEffect(() => {
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, []);

	if (!isOpen || !query) {
		return null;
	}

	if (sessionToken) {
		return null;
	}

	const handleClick = (likedResults = false) => {
		console.log(likedResults);
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}

		setResponse(likedResults);
		setHasSubmitted(true);

		pushToDataLayer({
			event: 'liked_results',
			Search_Querystring: queryString,
			Search_Term: query,
			selection: likedResults,
		});

		sessionStorage.setItem('collectionSurvey', 'alreadySeen');

		//hide after 5 seconds
		timerRef.current = setTimeout(() => {
			setIsOpen(false);
		}, 5000);
	};

	const handleClose = () => {
		setIsOpen(false);

		pushToDataLayer({
			event: 'liked_results',
			selection: null,
		});

		sessionStorage.setItem('collectionSurvey', 'alreadySeen');
	};

	return (
		<div className={`${styles.body} ${alwaysShow ? styles.alwaysShow : ''}`}>
			<button className={styles.button} onClick={handleClose}>
				<CloseIcon className={styles.icon} />
			</button>
			{hasSubmitted ? (
				<div>
					Submitted. More to say?{' '}
					<Link
						href={`https://airtable.com/appmOhFn8vkAvLXIl/pagXDAqXaCr5xshSg/form?prefill_Response=${response}&prefill_Query=${query}&hide_Query=true&hide_Response=true`}
						className={styles.link}
					>
						Leave feedback.
					</Link>
				</div>
			) : (
				<InitialMessage clickHandler={handleClick} />
			)}
		</div>
	);
};

const InitialMessage = ({ clickHandler }) => {
	return (
		<div className={styles.message}>
			How are these search results?
			<div className={styles.buttonContainer}>
				<button
					value="These results are what I was looking for."
					className={`${styles.button}${styles.icon} ${styles.thumbsIcon}`}
					onClick={() => clickHandler(true)}
				/>
				<button
					value="Not the results I was looking for."
					className={`${styles.button} ${styles.invert} ${styles.icon} ${styles.thumbsIcon}`}
					onClick={() => clickHandler(false)}
				/>
			</div>
		</div>
	);
};

export default CollectionFeedback;
